import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  wallet: {
    description: 'Message to prompt user to disable ad blocker for wallet registration',
    defaultMessage:
      'It appears that you might have tools installed to prevent third-party-tracking (like an ad-blocker). To continue, disable these tools in your browser then reload the page. You can re-enable them after you complete the setup.',
    id: '/3QVLs',
  },
  default: {
    description: 'Default message for detected ad blocker',
    defaultMessage: 'Please disable any ad-blockers you have installed and reload the page.',
    id: 'stejm3',
  },
});

export const thirdPartyTracking = ({ type }) => {
  return messages[type] || messages.default;
};
